import { Injectable } from '@angular/core';
import { OrderItemsServiceAdapter } from '../../../../core/integrations/nosERP/services/orderItems.service';

@Injectable({
  providedIn: 'root'
})
export class OrderItemsService {
  constructor(private orderItemsService: OrderItemsServiceAdapter) {}

  changeQuantity(id: string, quant: number) {
    return this.orderItemsService.changeQuantity(id, quant);
  }

  public deleteOrderItem(id: string) {
    return this.orderItemsService.deleteItem(id);
  }
}
